import React from 'react';
import { Box, Typography, Avatar, IconButton, Paper } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

// `actions` recebe o menu de ações do lead na prévia; o chat ao vivo não passa nada.
const ChatHeader = ({
  customer,
  onBack,
  onProfileClick,
  isPreview = false,
  actions = null,
}) => {
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const shortenName = (name) => {
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    if (parts.length <= 2) return name;
    return `${parts[0]} ${parts[parts.length - 1]}`;
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 1.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        bgcolor: 'background.paper',
        zIndex: 10,
      }}
    >
      {!isPreview && (
        <IconButton onClick={onBack} size="small">
          <ArrowBackIcon />
        </IconButton>
      )}

      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, cursor: onProfileClick ? 'pointer' : 'default' }}
        onClick={onProfileClick}
      >
        <Avatar
          sx={{
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            width: 40,
            height: 40,
          }}
        >
          {getInitials(customer?.display_name)}
        </Avatar>

        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2">
            {shortenName(customer?.display_name)}
          </Typography>
          {customer?.phone_number && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              {customer.phone_number}
            </Typography>
          )}
        </Box>
      </Box>

      {actions}

      {isPreview ? (
        <IconButton onClick={onBack} size="small">
          <CloseIcon />
        </IconButton>
      ) : null}
    </Paper>
  );
};

export default ChatHeader;
